import { DocPropKeys, retrieveDocumentProp, setDocumentProp } from "../../utils/helpers/CustomXmlHelper";
import { axiosInstance } from "../../utils/axios";

export type RagIndexStatusValue = "none" | "IN_PROGRESS" | "SUCCESS" | "FAILED" | "ABORTED" | "TIMEOUT";

export interface RagIndexStatus {
  status: RagIndexStatusValue;
  sentAt: string | null;
  statusUpdatedAt: string | null;
}

export interface RagIndexStatusChangedEvent extends RagIndexStatus {
  documentId: string;
}

export async function isRagIndexingEnabled(): Promise<boolean> {
  const prop = await retrieveDocumentProp(DocPropKeys.IsRagIndexingEnabled);
  return prop?.toLowerCase() === "true";
}

export async function setRagIndexingEnabled(enabled: boolean): Promise<void> {
  return setDocumentProp(DocPropKeys.IsRagIndexingEnabled, enabled.toString());
}

export async function prepareRagIndex(documentId: string): Promise<RagIndexStatus> {
  const response = await axiosInstance.post<RagIndexStatus>(`/rag/index/document/${documentId}/prepare`, null, {
    params: { notShowLoading: true },
  });
  return response.data;
}

export async function deleteDocumentFromRagIndex(documentId: string): Promise<void> {
  await axiosInstance.delete(`/rag/index/document/${documentId}/delete`, { params: { notShowLoading: true } });
}
